import { defineMessages } from 'react-intl';

const messages = defineMessages({
    more: {
        id: 'boxui.categorySelector.label.more',
        description: 'Button label for the "more" dropdown menu',
        defaultMessage: 'More',
    },
});

export default messages;
